/**
 * Scroll-reveal: заменяет page-load анимации на scroll-based
 * Добавляет класс .is-visible к элементам .anim1-.anim4 при входе во viewport
 */
(function () {
  'use strict';

  var ANIM_CLASSES = ['.anim1', '.anim2', '.anim3', '.anim4'];
  var SELECTOR = ANIM_CLASSES.join(', ');

  function init() {
    var elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: показать всё сразу
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function (el, i) {
      // Задержка через CSS custom property для stagger-эффекта внутри секции
      var delay = (i % 6) * 80;
      el.style.setProperty('--reveal-delay', delay + 'ms');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
